<!--suppress ALL -->
<template>
	<v-select :items="options" v-model="model" :label="label" item-text="display_name" :item-value="itemValue" :dark="dark"></v-select>
</template>

<script>
import LanguageModule from "src/store/modules/Language.module";
import SelectMixin from "src/mixins/SelectMixin";

export default {
	name: "languages-select",
	props: {
		value: {default: null},
		label:{
			type:String,
			default:"בחר"
		},
		itemValue:{
			type:String,
			default:"code"
		},
		dark:{
			type:Boolean,
			default: false
		}
	},
	components: {},
	mixins: [new SelectMixin(LanguageModule, "languages", [{'display_name': 'ללא הגבלה', 'id': ''}])],
};
</script>
